import React from "react";
import { faExclamationTriangle, faFlask } from '@fortawesome/free-solid-svg-icons'
import { Alert, AlertContent, AlertMessageTemplate, AlertFooter } from "./components/alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAlert: false
        }
    }

    render() {
        return (
            <>
                
                <div className="header">
                    <div className="content">
                        <div className="header-block">
                            <h1><FontAwesomeIcon icon={faFlask} /> System1</h1>
                            <a className="active">Dashboard</a>
                            <a>Accounts</a>
                            <a>Services</a>
                            <a>Billing</a>
                            <a>Reporting</a>
                        </div>

                        <div className="header-block">
                            <a href="http://jacobingalls.info">Jacob Ingalls</a>
                        </div>
                    </div>
                </div>

                <div className="hero" >
                    <div className="content">
                        <br />
                        <h1>The System1 Experiment</h1>
                        <p>System1 experiments with an exact two-color system.</p>
                        <button onClick={()=>this.setState({showAlert:true})} >Open Example Alert</button>
                        <br /> <br />
                    </div>
                </div>

                <hr />

                <div className="content">
                    <h2>The Idea</h2>
                    <p>
                        System1 is all about seeing if we could build modern websites using exactly two colors (although, the system will introduce anti-aliasing in someplaces.) We focused on the landing page, with interactions like alerts.
                    </p>

                    <p>
                        The first computers had output devices like mainframes, printers, tele-types, terminals, and 1-bit color depth monitors. These devices could not modulate their output, it was boolean. LED is illuminated, Pixel is on, letter is there, or not. It's fun to imagine what our computers would look/feel like if we were able to develop personal computers, but not fancy screens.
                    </p>

                    <p>
                        The early internet ran into many of the same issues, as their limitation was the performance of rendering (and the speed of downloading) complex and detailed assets from the internet.
                    </p>
                </div>

                <div className="content">
                    <h2>Color Palettes</h2>
                    <div className="tiles">
                        <ColorPalette name="Blue Angels" primary="#fc0" background="#334" />
                        <ColorPalette name="Printed" primary="#000" background="#fff" />
                        <ColorPalette name="Chalkboard" primary="#ccc" background="#101110" />
                        <ColorPalette name="Rose Garden" primary="#FF9EAB" background="#616D62" />
                        
                        <ColorPalette name="Rose Garden #2" primary="#FCBAC2" background="#373B37" />
                        <ColorPalette name="Steel Gray" primary="#445" background="#99A" />
                        <ColorPalette name="Steel Gray #2" primary="#445" background="#ccd" />

                        <CustomColorPalette />    
                    </div>
                </div>

                <Alert show={this.state.showAlert}>
                    <AlertContent>
                        <AlertMessageTemplate icon={faExclamationTriangle} 
                            title="Failed to save “Hello World”"
                            description="We attempted to send the request to the server."
                        >
                            <div style={{ fontSize: 12 }}>
                                <p style={{ marginBottom: 2 }}>Response from Server:</p>
                                <pre>
                                    <code>
                                    418: I'm a teapot
                                    </code>
                                </pre>
                            </div>
                        </AlertMessageTemplate> 
                    </AlertContent>
                    <AlertFooter left={
                        <>
                            <button className="link" onClick={()=>this.setState({showAlert:false})}>Info</button>
                        </>
                    } right={
                        <>
                            <button onClick={()=>this.setState({showAlert:false})}>Cancel</button>
                            <button className="default" onClick={()=>this.setState({showAlert:false})}>Save</button>
                        </>
                    }/>
                </Alert>
            </>
        )
    }
}

var ColorPalette = (props) => {
    return (
        <div className="tile" style={{ borderRadius: 5 }}>
            <h3 style={{paddingBottom: 6, borderBottom: "1px dashed var(--color-primary)"}}>{props.name}</h3>
            <br />

            <span style={{display: "inline-block", width: 100}}>Primary:</span>
            <span style={{display: "inline-block", width: 100, paddingTop: 4, paddingBottom: 4, fontFamily: "menlo, monospace"}}>{props.primary}</span>
            <br />

            <span style={{display: "inline-block", width: 100}}>Background:</span>
            <span style={{display: "inline-block", width: 100, paddingTop: 4, paddingBottom: 4, fontFamily: "menlo, monospace"}}>{props.background}</span>
            <br />
            <br />

            <button style={{width: "100%"}} onClick={() => {
                document.getElementById("body").style = `--color-primary: ${props.primary}; --color-background: ${props.background};`;
            }}>Apply</button>

            <button style={{width: "100%"}} onClick={() => {
                document.getElementById("body").style = `--color-primary: ${props.background}; --color-background: ${props.primary};`;
            }}>Apply Inverted</button>
        </div>
    );
}

class CustomColorPalette extends React.Component {
    constructor() {
        super();

        this.state = {
            primary: "#fff",
            background: "#000"
        }
    }

    render() {
        return (
            <div className="tile" style={{ borderRadius: 5 }}>
                <h3 style={{paddingBottom: 6, borderBottom: "1px dashed var(--color-primary)"}}>Custom Palette</h3>
                <br />
    
                <span style={{display: "inline-block", width: 100}}>Primary:</span>
                <input type="text" value="#fff" autoComplete="off" style={{width: 100}} onChange={(v) => {
                    this.setState({primary: v.target.value});
                }} value={this.state.primary} />
                <br />
    
                <span style={{display: "inline-block", width: 100}}>Background:</span>
                <input type="text" value="#fff" autoComplete="off" style={{width: 100}} onChange={(v) => {
                    this.setState({background: v.target.value});
                }} value={this.state.background} />
                <br />
                <br />
    
                <button style={{width: "100%"}} onClick={() => {
                    document.getElementById("body").style = `--color-primary: ${this.state.primary}; --color-background: ${this.state.background};`;
                }}>Apply</button>

                <button style={{width: "100%"}} onClick={() => {
                    document.getElementById("body").style = `--color-primary: ${this.state.background}; --color-background: ${this.state.primary};`;
                }}>Apply Inverted</button>
            </div>
        );
    }
}